// Stable identifiers describe main menu groups only. Submenus stay in SideBar.jsx.
export const SIDEBAR_ITEMS = [
  { id: "dashboard", label: "داشبورد" },
  { id: "users", label: "کاربران" },
  { id: "reports", label: "گزارشات" },
  { id: "categories", label: "دسته بندی" },
  { id: "vendor-categories", label: "دسته بندی غرفه" },
  { id: "vendors", label: "غرفه ها" },
  { id: "learn-categories", label: "دسته بندی آموزش ها" },
  { id: "learns", label: "آموزش ها" },
  { id: "products", label: "محصولات" },
  { id: "courses", label: "دوره ها" },
  { id: "vendor-products", label: "محصولات غرفه" },
  { id: "orders", label: "سفارشات" },
  { id: "shipping", label: "حمل و نقل" },
  { id: "faq", label: "سوالات متداول" },
  { id: "discounts", label: "تخفیفات" },
  { id: "campaigns", label: "کمپین‌ها" },
  { id: "coupons", label: "کوپن ها" },
  { id: "wallets", label: "کیف پول" },
  { id: "course-enrollments", label: "مدیریت خرید دوره" },
  { id: "affiliate-enrollments", label: "تراکنش ثبت نمایندگی" },
  { id: "articles", label: "مقالات" },
  { id: "sliders", label: "اسلایدر" },
  { id: "provinces", label: "استان و شهر" },
  { id: "public-fields", label: "قسمت های سایت" },
  { id: "files", label: "فایل ها" },
  { id: "backups", label: "بک آپ" },
  { id: "exports", label: "خروجی دیتا" },
  { id: "settings", label: "تنظیمات" },
];

export const DEFAULT_SIDEBAR_ORDER = SIDEBAR_ITEMS.map((item) => item.id);

export function normalizeSidebarOrder(value) {
  const allowed = new Set(DEFAULT_SIDEBAR_ORDER);
  const saved = Array.isArray(value) ? value.filter((id) => allowed.has(id)) : [];
  // New menu groups remain visible when an older saved order is loaded.
  return [...new Set([...saved, ...DEFAULT_SIDEBAR_ORDER])];
}
